// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1w_jS","modalFooterButton":"ModalNotes_modalFooterButton__3Q_zx"};